import { render, staticRenderFns } from "./SetBmdCTD.vue?vue&type=template&id=47e5c027&scoped=true&"
import script from "./SetBmdCTD.vue?vue&type=script&lang=js&"
export * from "./SetBmdCTD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e5c027",
  null
  
)

export default component.exports